import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWorker } from '../context/WorkerContext';
import HeaderShell from './HeaderShell';

const WorkerHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { messageCount } = useWorker();

  const isDashboardRoute = location.pathname === '/lkart/dashboard';
  const unreadCount = isDashboardRoute ? (messageCount || 0) : 0;

  return (
    <HeaderShell
      showHomeButton={false}
      showBellButton={isDashboardRoute}
      unreadCount={unreadCount}
      onBellClick={() => navigate('/lkart/dashboard/notifications')}
      showLogoutButton={false}
    />
  );
};

export default WorkerHeader;